import LiComponent from "./components/li";
import NewsCardComponent from "./components/news-card";
import UlComponent from "./components/ul";
import {getNewsData} from "./data/news";
import {renderPaginator} from "./render-paginator";
import {getNews} from "./require/get-news";
import {getUrlSearch} from "./utils/get-url-search";
import {isEmptyArray} from "./utils/is-empty-array";
import { isEmptyObject } from "./utils/is-empty-object";
import {RenderPosition, render} from "./utils/render";
import {renderShowMoreButton} from "./utils/render-show-more-button";
import {setPageUrl} from "./utils/set-page-url";

const renderNewsList = (container, newsList = {}, isAdd = false) => {
  if (!container) {
    return;
  }

  if (!isAdd) {
    container.innerHTML = ``;
    window.scrollTo(0, 0);
  }

  if (isEmptyArray(Object.keys(newsList))) {
    return;
  }

  let listElement = container.querySelector(`.news__list`);
  if (!listElement) {
    const listComponent = new UlComponent(`news__list`);
    render(container, listComponent.getElement(), RenderPosition.BEFOREEND);
    listElement = listComponent.getElement();
  }

  Object.values(newsList)
  .forEach((news) => {
    const liItemComponent = new LiComponent({
      className: `news__item`,
    });
    render(listElement, liItemComponent.getElement(), RenderPosition.BEFOREEND);

    const productCardComponent = new NewsCardComponent({
      data: getNewsData(news),
    });

    render(liItemComponent.getElement(), productCardComponent.getElement(), RenderPosition.BEFOREEND);
  });
};


export const renderNewsPage = (newsList) => {
  // const backButton = document.querySelector(`.main-page__backButton`);
  // if (backButton) {
  //   backButton.addEventListener(`click`, () => {
  //     if (history.length > 1) {
  //       history.back();
  //     } else {
  //       if (window.location.pathname === `/news`) {
  //         window.open(`/`, `_self`);
  //       } else {
  //         window.open(`/news`, `_self`);
  //       }
  //     }
  //   });
  // }

  if (!newsList || isEmptyObject(newsList)) {
    return;
  }

  const newsElement = document.querySelector(`.news-page__content`);
  renderNewsList(newsElement, newsList.news);

  const getNewsList = (isAdd = false) => {
    // productItemsElement.dataset.state = `loader`;
    getNews({
      // filter: getFilter(filter),
      // sort,
      activePage: activePage2,
      resolveHandler: (response) => {
        renderNewsList(newsElement, response.news, isAdd);
        // renderItems(response.items, isAdd);
        // productItemsElement.dataset.state = `list`;


        // renderShowMoreButton(+countPerPage, +response.count, +activePage2);
        renderShowMoreButton(showAllElement, +response.page_size, +response.count, +activePage2, onShowMoreButtonCLickHandler);
        renderPaginator(paginatorElement, +response.page_count, activePage2, (page) => {
          activePage2 = page;
          setPageUrl(activePage2);
          getNewsList();
        });
      }
    });
  };

  const paginatorElement = document.querySelector(`.paginator`);
  const showAllElement = document.querySelector(`.product-list-page__show-all`);

  let activePage2 = +getUrlSearch(`p`) || 1;

  const onShowMoreButtonCLickHandler = () => {
    activePage2 = +activePage2 + 1;
    setPageUrl(activePage2);
    getNewsList(true);
  };

  renderShowMoreButton(showAllElement, +newsList.page_size, +newsList.count, +activePage2, onShowMoreButtonCLickHandler);

  renderPaginator(paginatorElement, +newsList.page_count, activePage2, (page) => {
    activePage2 = page;
    setPageUrl(activePage2);
    getNewsList();
  });
};
